import useMenuBarItems from './useMenuBarItems'
import useGeneralItems from './useGeneralItems'
import useHomeItems from './useHomeItems'
import useAssessmentItems from './useAssessmentItems'

export default { useMenuBarItems, useGeneralItems, useHomeItems, useAssessmentItems }